module.exports = "/_next/static/images/967381714dab4c18405dcabcaf5eaebd-icon_card.png";